// --- Material UI ---
import {FormControl, FormLabel, Stack, ToggleButtonGroup, Tooltip} from "@mui/material";
import {Info} from "@mui/icons-material";

const ToggleButtonGroupField = ({children, input, label, tooltip, ...rest}) => (
  <FormControl>
    <FormLabel sx={{pb: 1}}>
      <Stack direction="row" sx={{gap: 1}}>
        {label}
        {
          tooltip &&
          <Tooltip title={tooltip}>
            <Info/>
          </Tooltip>
        }
      </Stack>
    </FormLabel>
    <ToggleButtonGroup
      {...input}
      onChange={(_event, value) => input.onChange(value)}
      exclusive
      {...rest}
    >
      {children}
    </ToggleButtonGroup>
  </FormControl>
);

export {
  ToggleButtonGroupField
};
